// extracted by mini-css-extract-plugin
module.exports = {"flashing":"styles_flashing__2Hszq","dotFlashing":"styles_dotFlashing__2Mgh7"};